export interface UserSettings {
  userId: string;
  acceptedTerms: boolean;
}

export interface UseQueryUserSettingsParams {
  onError?: (err: unknown) => void;
  onSuccess?: (data: UserSettings | undefined) => void;
  userId: string;
}

export interface UserSettingsContext {
  previousUserSettings: UserSettings;
}

export interface UseMutationUserSettingsVariables extends UserSettings {
  isNew: boolean;
}

export enum UserSettingsErrors {
  NOT_FOUND = 'not found',
}
